import { render } from "./FundNews.vue?vue&type=template&id=633333dc&scoped=true"
import script from "./FundNews.vue?vue&type=script&lang=js"
export * from "./FundNews.vue?vue&type=script&lang=js"

import "./FundNews.vue?vue&type=style&index=0&id=633333dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633333dc"]])

export default __exports__